//angular
import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
//app
import { GridService, LoaderService } from 'src/app/_core/services';
import { VisibleState } from '../../../../app.data';
import { DialogManageFiltersComponent } from '../../_shared/dialog/manage-filters/manage-filters.component';
import { MetaService } from 'src/app/_core/services/meta.service';

@Component({
  selector: 'panel-filters',
  templateUrl: './panel-filters.component.html',
  // animations: [panelPreferences]
})

export class PanelFiltersComponent implements OnInit {
  status: boolean = false;
  statusPanel: string = 'isHidden';
  dialogConfirmation: MatDialogRef<DialogManageFiltersComponent>;

  @Input()
  panelFiltersSectionId: string;

  @Input()
  panelFiltersGroupDisplayName: string;

  @Input()
  numberOfItems: number = 0;

  @Output()
  onSetDefaultValues: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onGetGridData: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _dialog: MatDialog,
    private _iconRegistry: MatIconRegistry,
    private _loader: LoaderService,
    private _sanitizer: DomSanitizer,
    public _grid: GridService,
    public _meta: MetaService
  ) {
    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
    this._iconRegistry.addSvgIcon('ico-drag', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-drag-02.svg'));
  }

  ngOnInit() {
  }

  async onFilterChange(_filter: any) {
    this.onSetDefaultValues.emit();
    this._grid.selectedFilterLabel = _filter.label;
    this._grid.selectedFilterId = _filter.id;

    await this._grid.updateQueryParams(null, null, null, this._grid.selectedFilterId)

    if (this._grid.statusSnackBar == VisibleState.isVisible) {
      this._grid.closeBulkDialog();
    }

    this.onGetGridData.emit();
  }

  openManageFilters() {
    this.dialogConfirmation = this._dialog.open(DialogManageFiltersComponent, {
      panelClass: ['custom-mat-dialog', 'mat-dialog-manage-filter'],
      data: {
        sectionId: this.panelFiltersSectionId,
        groupDisplayName: this.panelFiltersGroupDisplayName
      }
    });
    this.dialogConfirmation.afterClosed().subscribe(
      resCode => {
        if (resCode) {
          this._grid.collectionOfFilter.push(resCode.data);
          this._grid.selectedFilterId = resCode.data.id;
          this._grid.selectedFilterLabel = resCode.data.label;
          this._loader.stopPageLoader();
          this.onGetGridData.emit();
        }
      }
    );
  }

}
